// Never leave a call after a rejected join: it may belong to another device.
export async function joinWebCall({ call, request, connect, signal, options = {}, joinedResponse = null }) {
  let joined = Boolean(joinedResponse);
  let connectionId = joinedResponse && joinedResponse.connectionId;
  let runtime = null;
  const active = () => { if (signal.aborted) throw new DOMException('Call cancelled', 'AbortError'); };
  try {
    active();
    const response = joinedResponse || await request('/api/chats/calls/' + call.id + '/join', { method: 'POST', data: {} });
    connectionId = response.connectionId;
    joined = true;
    active();
    runtime = await connect({ ...options, signal, livekitUrl: response.livekitUrl, livekitToken: response.livekitToken, video: call.kind === 'video' });
    active();
    return { runtime, call: response.call || call, connectionId };
  } catch (error) {
    if (runtime) await runtime.disconnect().catch(() => {});
    if (joined) await request('/api/chats/calls/' + call.id + '/leave', { method: 'POST', data: { connectionId: connectionId || null } }).catch(() => {});
    throw error;
  }
}
